import React from 'react'

const MDB4DropdownItemButton = ({ children, ...rest }) => (
  <button type='button' {...rest}>
    {children}
  </button>
)

export default MDB4DropdownItemButton
